import {
  happyEmojiIcon,
  joyfulEmojiIcon,
  negativeEmojiIcon,
  neutralEmojiIcon,
  upsetEmojiIcon,
} from '@/assets/images';
import ExperienceType from '@/constants/ExperienceType';
import translate from '@/lib/intl/translate';

const ExperienceRatingsConfig = [
  {
    descriptor: ExperienceType.ANGRY,
    icon: upsetEmojiIcon,
    tooltip: translate('BAD'),
  },
  {
    descriptor: ExperienceType.SAD,
    icon: negativeEmojiIcon,
    tooltip: translate('NOT_GOOD'),
  },
  {
    descriptor: ExperienceType.NEUTRAL,
    icon: neutralEmojiIcon,
    tooltip: translate('OK'),
  },
  {
    descriptor: ExperienceType.HAPPY,
    icon: happyEmojiIcon,
    tooltip: translate('GOOD'),
  },
  {
    descriptor: ExperienceType.EXCITED,
    icon: joyfulEmojiIcon,
    tooltip: translate('GREAT'),
  },
];

export default ExperienceRatingsConfig;
